module.exports = __webpack_public_path__ + "media/images/bg/mosaic/calligraphy-bee45fb83ed516fb3257b52f47e3a96a.jpg";